import { Injectable } from '@angular/core';
import { Form } from 'src/app/interfaces/form';
import { APIProviderService } from '../api/api.provider.service';

@Injectable({
  providedIn: 'root'
})
export class FormsProviderService extends APIProviderService<Form> {
  protected override get attributeURL(): string {
    return `${super.attributeURL}/Forms`;
  }
}
